// extracted by mini-css-extract-plugin
module.exports = {"formItem":"InventoryStockIn_formItem__eusLy"};